import { Component, Inject, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { DialogActions } from "src/app/components/dialogs/dialog.model";
import { PurchasingService } from "../purchasing.service";
import { Observable, Subject, merge, of } from "rxjs";
import { debounceTime, distinctUntilChanged, filter, map, share, switchMap, takeUntil, tap } from "rxjs/operators";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SnackbarComponent } from "src/app/components/snackbar/snackbar.component";
import { ScannerService } from "src/app/services/scanner.service";

@Component({
  selector: "app-scan-po",
  templateUrl: "./scan-po.component.html",
  styleUrls: ["./scan-po.component.scss"],
})
export class ScanPoComponent implements OnInit {
  actions: DialogActions[];
  scanForm: FormGroup = new FormGroup({
    item: new FormControl("", Validators.required),
    location: new FormControl("", Validators.required),
    qty: new FormControl(1, [Validators.required]),
  });
  poId: number;
  filteredOptionsLocation$: Observable<any[]>;
  filteredOptionsItem$: Observable<any>;
  items: any;
  purchaseOrderItemId: any;
  private destroy$ = new Subject<void>();
  spinLoader :boolean= false;
  disable:boolean= true;
  successAudio = "../../../assets/sound/beep-08b.wav";
  errorAudio = "../../../assets/sound/beep-5.wav";
  _scanInto: string | number;
  itemMsg: any;
  locationMsg: any;
  get scanInto() {
    return this._scanInto;
  }

  set scanInto(newValue: string | number) {
    this._scanInto = newValue;
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<ScanPoComponent>,
    private purchasingService: PurchasingService,
    private snackBar : MatSnackBar,
    private scannerService: ScannerService
  ) {}

  ngOnInit(): void {
    this.poId = this.data.data.poId;
    this.items = this.data.data.items;
     this.getLocation();
    if(this.data?.data?.isItem){
      this.scanForm.get("qty").setValue(this.data.data.qty);
      this.scanForm.get("item").setValue( this.items);
    }  
    this.filteredOptionsLocation$ = this.scanForm.get("location").valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      filter(e => typeof e === 'string'),
      switchMap(value =>  this.purchasingService.TypeAheadItemForLocation({ qry: value, warehouseId: this.data.data.warehouseId })),
      share()
    );

    this.filteredOptionsLocation$
      .pipe(takeUntil(this.destroy$))
      .subscribe((items) => {
        if (!items.length) {
          this.filteredOptionsLocation$ = new Observable<any[]>(observer => {
            observer.next(items);
            observer.complete();
          });
          this.locationMsg = "Location not found";
          this.scanForm.get("location").setValidators(Validators.required);
          this.scanForm.get("location").updateValueAndValidity();

        } else {
          this.locationMsg = null;
          this.filteredOptionsLocation$ = new Observable<any[]>(observer => {
            observer.next(items);
            observer.complete();
          });
        }
        if (typeof this.scanForm.get("location").value === "string") {
          const item = items.find(
            (res) =>
              res.name.toLowerCase() ===
              this.scanForm.get("location").value.toLowerCase()
          );
          if (item) {
            this.scanForm.patchValue({ location: item }, { emitEvent: false });
          }
        }
      });

      if(!this.data?.data?.isItem) {
          this.filteredOptionsItem$ = merge(
            this.scanForm.get("item").valueChanges
          ).pipe(
            tap((e) => e),
            switchMap(() => of(this.items)),
            map((item: any) => {
              if (this.scanForm.controls["item"].value) {
                for (var i = 0; i < this.items.length; i++) {
                  if (
                    this.items[i].vendorItemName
                      .toLowerCase()
                      .includes(this.scanForm.controls["item"].value.toLowerCase())
                  ) {
                    this.itemMsg = null;
                    break;
                  } else {
                    this.itemMsg = "Item not found";
                  }
                }
              } else {
                this.itemMsg = null;
              }
              return item.filter((item) => {
                if (item.vendorItemName) {
                  return item.vendorItemName
                    .toLowerCase()
                    .includes(this.scanForm.controls["item"].value.toLowerCase());
                }
              });
            })
          );
        }
  }

  displayFn(item) {
    return item ? item : "";
  }

  action(e) {
    if (e === "Save") {
      this.save();
    } else if (e === "Cancel") {
      this.close();
    }
  }

  save() {
    this.spinLoader= true;
    const payload= {
        locationId: this.scanForm.value.location.locationId,
        poId: this.poId,
        items: [{itemId:this.data?.data?.itemId ? this.data.data.itemId : this.purchaseOrderItemId, qty: this.scanForm.value.qty} ]
      }

    this.purchasingService.savePoItemToLocation(payload).subscribe((e)=>{
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: "Po item to location saved successfully",
            action: 'Dismiss',
            type: 'success',
          },
        }
     );
     this.spinLoader = false;
     if(this.data?.data?.isItem){
      this.dialogRef.close({refresh:true,qty:this.scanForm.value.qty})
     } else {
      this.dialogRef.close('refresh');
     }
    },
    (error)=>{     
      this.spinLoader = false; 
      this.dialogRef.close();
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: error.error.error,
            action: 'Dismiss',
            type: 'error',
          },
        }
      );
    });
  }

  close() {
    this.dialogRef.close();
  }

  onSelectionChange(event){
    for (var i = 0; i < this.items.length; i++) {
      if (this.items[i].vendorItemName == event){
        this.purchaseOrderItemId = this.items[i].purchaseOrderItemId;
        this.disable = false;
        break;
       } else {
        this.disable = true;
      }
   }
  }

  displayWith(value) {
    if (value) {
      return value.name;
    }
  }

  setScanner() {
    this.scannerService.scanned
      .pipe(takeUntil(this.destroy$))
      .subscribe((e) => {
         if (this.scanInto === "item") { 
          let idx = this.items.findIndex((res)=> res.vendorItemName == e);
           if(idx !== -1){
             this.scanForm.get("item").setValue(e);
             this.playAudio(true);
           }else{
             this.playAudio(false);
           }
         } else if (this.scanInto === "location") {
           let value : any;
           this.purchasingService.TypeAheadItemForLocation(value ={qry: e, warehouseId: this.data.data.warehouseId}).subscribe((res)=>{
             if(res){
               this.scanForm.patchValue({ location: res[0] }, { emitEvent: false });
               this.playAudio(true);
             }else{
               this.playAudio(false);
             }
           })
         } else {
           this.snackBar.openFromComponent(SnackbarComponent, {
             duration: 3000,
             horizontalPosition: "center",
             data: {
               title: "Please click the scan button",
               action: "Dismiss",
               type: "info",
             },
           });
         }
      });
  }

  private playAudio(isSuccess: boolean) {
    const audio = new Audio();
    isSuccess ? (audio.src = this.successAudio) : (audio.src = this.errorAudio);
    audio.load();
    audio.play();
  }

  getLocation() {
    const value = {
      qry: "",
      warehouseId: this.data.data.warehouseId
    }
    this.purchasingService.TypeAheadItemForLocation(value).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res: any[]) => {
        if (res) {
          this.filteredOptionsLocation$ = new Observable<any[]>(observer => {
            observer.next(res);
            observer.complete();
          });
        }
      },
      error: (err) => {
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: "Operation Unsuccessful",
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
      }

    })
  }
}
